import { useEffect, useState } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { getBidderOnboardingOfUser } from "services";
import { useSelector, useDispatch } from "react-redux";
import { setBidderOnboarding, setOnboarding } from "store";
import BidderOnboardingFormV2 from "../../../bidder/Tabs/onboarding/BidderOnboardingFormV2";

export default function ProfileDetailsWithBidderForm() {
  const user = useSelector((state: any) => {
    return state.bidderAuth?.user;
  });

  const dispatch = useDispatch();
  // const modalBaseClasses =
  //   "fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 transition-opacity duration-300 ease-out";
  // const [profileIncompleteModal, setProfileIncompleteModal] = useState(false);
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const init = async () => {
    if (user?.uuid) {
      const onboardingData: any = await getBidderOnboardingOfUser(user?.uuid);

      if (onboardingData) {
        dispatch(setBidderOnboarding(onboardingData));
        dispatch(setOnboarding(onboardingData));
      }
      // if (onboardingData?.status !== "active") {
      //   setProfileIncompleteModal(true);
      // }
    }
  };
  useEffect(() => {
    init();
  }, [user?.uuid]);
  return (
    <>
      <div className="lg:max-w-[745px]" id="onboarding-form-top">
        <div className=" w-full mt-7 lg:mt-[34px]">
          <BidderOnboardingFormV2
            onOuterSubmitComplete={() => {
              setVerifyModalOpen(true);
            }}
          />
        </div>
        {/* {profileIncompleteModal && (
          <div className={modalBaseClasses}>
            <div className="bg-white p-12 pt-4 pb-4 rounded-lg shadow-lg flex flex-col items-center space-y-4 lg:max-w-[600px] ">
              <p className="font-openSans font-semibold text-mobile-body-md lg:text-[22px] leading-4  lg:leading-[30px]">
                {" "}
                Complete Your Profile !
              </p>
              <p className="font-openSans font-normal text-center text-brand-textGrey text-mobile-body-md lg:text-web-subheading leading-4  lg:leading-[30px]">
                Please complete your profile to explore the properties
                seamlessly
              </p>
              <Button
                className="mt-4 px-4 py-2 bg-brand-bgBlack text-white rounded"
                onClick={() => setProfileIncompleteModal(false)}
              >
                Close
              </Button>
            </div>
          </div>
        )} */}
        {verifyModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white p-12 pt-4 pb-4 rounded-lg shadow-lg flex flex-col items-center space-y-4">
              <p className="font-openSans font-semibold text-mobile-body-md lg:text-[22px] leading-4  lg:leading-[30px]">
                {" "}
                Changes Saved
              </p>
              <p className="font-openSans font-normal text-brand-textGrey text-mobile-body-md lg:text-web-subheading leading-4  lg:leading-[30px]">
                The User Profile Details have been updated{" "}
              </p>
              <Button
                className="mt-4 px-4 py-2 bg-brand-bgBlack text-white rounded"
                onClick={() => setVerifyModalOpen(false)}
              >
                Close
              </Button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
